import React from "react";

// default layout
import Default from "../layouts/dashboard/default";

// Dashboard
import Index from "../views/dashboard/index";

import WithRoleGuard from "../utilities/withRoleGuard";

// user pages
import Userprofile from "../views/dashboard/user/user-profile";
import UserAdd from "../views/dashboard/user/user-add";
import UserList from "../views/dashboard/user/user-list";
import LeaveList from "../views/dashboard/manage/leave-list";

import AuthRoute from "./auth-router";
import InstructorList from "../views/dashboard/manage/instructor-list";
import UserEdit from "../views/dashboard/user/user-edit";
import LeaveDetail from "../views/dashboard/manage/leave-detail";
import LeaveUse from "../views/dashboard/manage/leave-use";
import ScheduleList from "../views/dashboard/lesson/schedule-list";
import ScheduleAdd from "../views/dashboard/lesson/schedule-add";
import SalesList from "../views/dashboard/sales/sales-list";
import SalesAdd from "../views/dashboard/sales/sales-add";
import SalesEdit from "../views/dashboard/sales/sales-edit";
import InstructorEdit from "../views/dashboard/manage/instructor-edit";
import InstructorAdd from "../views/dashboard/manage/instructor-add";
import InstructorWageList from "../views/dashboard/manage/instructor-wage/instructor-wage-list";
import InstructorWageView from "../views/dashboard/manage/instructor-wage/instructor-wage-view";
import StoreList from "../views/dashboard/store/store-list";
import StoreAdd from "../views/dashboard/store/store-add";
import StoreEdit from "../views/dashboard/store/store-edit";
import LessonReservation from "../views/dashboard/lesson/reservation";
import LessonReservationHistory from "../views/dashboard/lesson/reservation-history";
import UserAnalysis from "../views/dashboard/user/user-analysis";
import SalesAnalysis from "../views/dashboard/sales/sales-analysis";
import UserSurvey from "../views/dashboard/user/user-survey";
import SalesReceiveList from "../views/dashboard/sales/sales-receive-list";
import SalesReceiveLogAdd from "../views/dashboard/sales/sales-receive-add";
import ConfigProgram from "../views/dashboard/config/program.js";
import ConfigLesson from "../views/dashboard/config/lesson";
import ConfigLessonAdd from "../views/dashboard/config/lesson-add";
import ConfigLessonEdit from "../views/dashboard/config/lesson-edit";
import ConfigProgramAdd from "../views/dashboard/config/program-add";
import ConfigProgramEdit from "../views/dashboard/config/program-edit";
import LeaveRequest from "../views/dashboard/manage/leave-request";
import InstructorWageSearch from "../views/dashboard/manage/instructor-wage/instructor-wage-search";
import ConfigGroupLesson from "../views/dashboard/config/group-lesson";
import SalesStatistics from "../views/dashboard/store/sales-statistics";
import InstructorStatistics from "../views/dashboard/store/instructor-statistics";
import InstructorWageMonthSearch from "../views/dashboard/manage/instructor-wage/instructor-wage-month-search";
import InstructorOvertime from "../views/dashboard/manage/instructor-wage/instructor-overtime";

import Error404 from "../views/dashboard/errors/error404";
import Error500 from "../views/dashboard/errors/error500";

export const DefaultRouter = [
  {
    path: "/",
    element: <Default />,
    children: [
      {
        path: "",
        element: <AuthRoute element={<Index />} />,
      },

      //User
      {
        path: "/user/user-profile",
        element: <WithRoleGuard component={Userprofile} />,
        name: "User Profile",
        active: "pages",
        subActive: "User",
      },
      {
        path: "/user/user-add",
        element: <WithRoleGuard component={UserAdd} />,
        name: "User Add",
        active: "pages",
        subActive: "User",
      },
      {
        path: "/user/user-edit/:userId",
        element: <WithRoleGuard component={UserEdit} />,
        name: "User Edit",
        active: "pages",
        subActive: "User",
      },
      {
        path: "/user/user-list",
        element: <WithRoleGuard component={UserList} />,
        name: "User List",
        active: "pages",
        subActive: "User",
      },
      {
        path: "/user/user-analysis",
        element: <WithRoleGuard component={UserAnalysis} />,
        name: "User Analysis",
        active: "pages",
        subActive: "User",
      },
      {
        path: "/user/user-survey/:userId",
        element: <WithRoleGuard component={UserSurvey} />,
        name: "User Survey",
        active: "pages",
        subActive: "User",
      },

      // Sales
      {
        path: "/sales/sales-list",
        element: <WithRoleGuard component={SalesList} />,
        name: "Sales List",
        active: "pages",
        subActive: "Sales",
      },
      {
        path: "/sales/sales-receive-list",
        element: <WithRoleGuard component={SalesReceiveList} />,
        name: "Sales Receive List",
        active: "pages",
        subActive: "SalesReceive",
      },
      {
        path: "/sales/:salesId/sales-receive-add",
        element: <WithRoleGuard component={SalesReceiveLogAdd} />,
        name: "Sales Receive Log Add",
        active: "pages",
        subActive: "SalesReceiveAdd",
      },
      {
        path: "/sales/sales-add",
        element: <WithRoleGuard component={SalesAdd} />,
        name: "Sales Add",
        active: "pages",
        subActive: "Sales",
      },
      {
        path: "/sales/sales-edit/:salesId",
        element: <WithRoleGuard component={SalesEdit} />,
        name: "Sales Edit",
        active: "pages",
        subActive: "Sales",
      },
      {
        path: "/sales/sales-analysis",
        element: <WithRoleGuard component={SalesAnalysis} />,
        name: "Sales Analysis",
        active: "pages",
        subActive: "Sales",
      },

      // Lesson
      {
        path: "/lesson/schedule-list",
        element: <WithRoleGuard component={ScheduleList} />,
        name: "Lesson Schedule List",
        active: "pages",
        subActive: "Lesson",
      },
      {
        path: "/lesson/schedule-add",
        element: <WithRoleGuard component={ScheduleAdd} />,
        name: "Lesson Schedule Add",
        active: "pages",
        subActive: "Lesson",
      },
      {
        path: "/lesson/reservation",
        element: <WithRoleGuard component={LessonReservation} allowedRoles={["ROLE_USER"]} />,
        name: "Lesson reservation",
        active: "pages",
        subActive: "Lesson",
      },
      {
        path: "/lesson/reservation-history",
        element: <WithRoleGuard component={LessonReservationHistory} allowedRoles={["ROLE_USER"]} />,
        name: "Lesson reservation history",
        active: "pages",
        subActive: "Lesson",
      },

      // Manage
      {
        path: "/manage/instructor-list",
        element: <WithRoleGuard component={InstructorList} />,
        name: "Instructor List",
        active: "pages",
        subActive: "Instructor",
      },
      {
        path: "/manage/instructor-add",
        element: <WithRoleGuard component={InstructorAdd} />,
        name: "Instructor Add",
        active: "pages",
        subActive: "Instructor",
      },
      {
        path: "/manage/instructor-edit/:instructorId",
        element: <WithRoleGuard component={InstructorEdit} />,
        name: "Leave Edit",
        active: "pages",
        subActive: "Leave",
      },
      {
        path: "/manage/leave-list",
        element: <WithRoleGuard component={LeaveList} />,
        name: "Leave List",
        active: "pages",
        subActive: "Leave",
      },
      {
        path: "/manage/leave-use",
        element: <WithRoleGuard component={LeaveUse} />,
        name: "Leave Use",
        active: "pages",
        subActive: "Leave",
      },
      {
        path: "/manage/leave-detail/:leaveId",
        element: <WithRoleGuard component={LeaveDetail} />,
        name: "Leave Detail",
        active: "pages",
        subActive: "Leave",
      },
      {
        path: "/manage/leave-request/:instructorId",
        element: <WithRoleGuard component={LeaveRequest} />,
        name: "Leave Request",
        active: "pages",
        subActive: "Leave",
      },
      {
        path: "/manage/instructor-wage/instructor-search",
        element: <WithRoleGuard component={InstructorWageSearch} />,
        name: "Instructor Wage Search",
        active: "pages",
        subActive: "Instructor",
      },
      {
        path: "/manage/instructor-wage/month-search",
        element: <WithRoleGuard component={InstructorWageMonthSearch} />,
        name: "Instructor Wage Search",
        active: "pages",
        subActive: "Instructor",
      },
      {
        path: "/manage/instructor-wage/overtime",
        element: <WithRoleGuard component={InstructorOvertime} />,
        name: "Instructor Overtime",
        active: "pages",
        subActive: "Instructor",
      },
      {
        path: "/manage/instructor-wage/list",
        element: <WithRoleGuard component={InstructorWageList} />,
        name: "Instructor Wage List",
        active: "pages",
        subActive: "Instructor",
      },
      {
        path: "/manage/instructor-wage/:instructorId",
        element: <WithRoleGuard component={InstructorWageView} />,
        name: "Instructor Wage Detail",
        active: "pages",
        subActive: "Instructor",
      },
      
      // Store
      {
        path: "/store/store-list",
        element: <WithRoleGuard component={StoreList} />,
        name: "Store List",
        active: "pages",
        subActive: "Store",
      },
      {
        path: "/store/store-add",
        element: <WithRoleGuard component={StoreAdd} />,
        name: "Store Add",
        active: "pages",
        subActive: "Store",
      },
      {
        path: "/store/store-edit/:storeId",
        element: <WithRoleGuard component={StoreEdit} />,
        name: "Store Edit",
        active: "pages",
        subActive: "Store",
      },
      {
        path: "/store/sales-statistics",
        element: <WithRoleGuard component={SalesStatistics} />,
        name: "Sales Statistics",
        active: "pages",
        subActive: "Store",
      },
      {
        path: "/store/instructor-statistics",
        element: <WithRoleGuard component={InstructorStatistics} />,
        name: "Instructor Statistics",
        active: "pages",
        subActive: "Store",
      },

      // Config
      {
        path: "/config/lesson",
        element: <WithRoleGuard component={ConfigLesson} />,
        name: "config lesson",
        active: "pages",
        subActive: "ConfigLesson",
      },
      {
        path: "/config/lesson/add",
        element: <WithRoleGuard component={ConfigLessonAdd} />,
        name: "config lesson",
        active: "pages",
        subActive: "ConfigLesson",
      },
      {
        path: "/config/lesson/:id",
        element: <WithRoleGuard component={ConfigLessonEdit} />,
        name: "config lesson",
        active: "pages",
        subActive: "ConfigLesson",
      },
      {
        path: "/config/program",
        element: <WithRoleGuard component={ConfigProgram} />,
        name: "config program",
        active: "pages",
        subActive: "ConfigProgram",
      },
      {
        path: "/config/program/add",
        element: <WithRoleGuard component={ConfigProgramAdd} />,
        name: "config program",
        active: "pages",
        subActive: "ConfigProgram",
      },
      {
        path: "/config/program/:id",
        element: <WithRoleGuard component={ConfigProgramEdit} />,
        name: "config program",
        active: "pages",
        subActive: "ConfigProgram",
      },
      {
        path: "/config/group-lesson",
        element: <WithRoleGuard component={ConfigGroupLesson} />,
        name: "config group lesson",
        active: "pages",
        subActive: "ConfigGroupLesson",
      },

      // Error Pages
      {
        path: "/error/404",
        element: <Error404 />,
        name: "404 Not Found",
        active: "pages",
        subActive: "Error",
      },
      {
        path: "/error/500",
        element: <Error500 />,
        name: "500 Internal Server Error",
        active: "pages",
        subActive: "Error",
      },
    ],
  },
];
